import React from 'react';
import { useTranslation } from 'react-i18next'
import { useScrollTop } from '../../hooks/useScrollTop';
import { Content } from './pl/Content';
import './privacyPolicy.scss'

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    useScrollTop();
    const images = {
        main2: require('../../images/CleanBg.png'),
        icon: require('../../images/privacyPolicy/icon.png'),
    };
    return (
        <section id="PrivacyPolicy" className="hero-wrap" style={{ backgroundImage: `url("${images.main2}")` }}>
            <div className="container">
                <div className='d-flex align-items-center justify-content-center'>
                    <h2>{t('privacyPolicy.header')}</h2>
                </div>
                <div className="row align-items-center justify-content-center">
                    <div style={{ backgroundImage: `url("${images.icon}")`, width: '75px', height: '75px', backgroundSize: 'cover' }}></div>
                </div>
                <Content />
            </div>
        </section>
    );
}

export default PrivacyPolicy;
